import { Link } from 'react-router-dom'
import { Bell } from 'lucide-react'
import { CarbonLogo } from './CarbonLogo'

// WizardNav — presentational. The top navigation bar shown above the wizard.
export function WizardNav() {
  return (
    <nav className="nav">
      <div className="nav-inner">
        <Link to="/projects">
          <CarbonLogo />
        </Link>
        <ul className="nav-links">
          <li><Link to="/projects">Workspace</Link></li>
          <li><a className="active">New Project</a></li>
          <li><Link to="/projects">Templates</Link></li>
          <li><Link to="/projects">Activity</Link></li>
        </ul>
        <div className="nav-actions">
          <button className="btn-icon" title="Notifications" type="button">
            <Bell size={14} />
          </button>
          <div className="avatar">CK</div>
        </div>
      </div>
    </nav>
  )
}
